export default __webpack_public_path__ + "static/media/result-computer.673d40a4.jpg";